<template>

    <layout>
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <nav class="mypages-nav">
                        <ul class="nav flex-column">
                            <li
                                :class="{'nav-link':true, 'active':route().current() === 'auth.myaccount.index'}"
                            >
                                <inertia-link
                                    :href="route('auth.myaccount.index')"
                                >
                                    {{ lang('all.dashboard') }}
                                </inertia-link>
                            </li>
                            <li
                                :class="{'nav-link':true, 'active':route().current() === 'auth.myaccount.orders.index'}"
                            >
                                <inertia-link
                                    :href="route('auth.myaccount.orders.index')"
                                >
                                    {{ lang('all.bestellingen') }}
                                </inertia-link>
                            </li>
                            <li
                                :class="{'nav-link':true, 'active':route().current() === 'auth.myaccount.invoices.index'}"
                            >
                                <inertia-link
                                    :href="route('auth.myaccount.invoices.index')"
                                >
                                    {{ lang('invoices.invoices') }}
                                </inertia-link>
                            </li>
                            <li
                                :class="{'nav-link':true, 'active':route().current() === 'auth.myaccount.addresses.index'}"
                            >
                                <inertia-link
                                    :href="route('auth.myaccount.addresses.index')"
                                >
                                    {{ lang('all.adressen') }}
                                </inertia-link>
                            </li>
                            <li
                                :class="{'nav-link':true, 'active':route().current() === 'auth.myaccount.details.index'}"
                            >
                                <inertia-link
                                    :href="route('auth.myaccount.details.index')"
                                >
                                    {{ lang('all.accountgegevens') }}
                                </inertia-link>
                            </li>
                            <li
                                :class="{'nav-link':true, 'active':false}"
                            >
                                <inertia-link
                                    :href="route('auth.logout')"
                                >
                                    {{ lang('all.uitloggen') }}
                                </inertia-link>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="col-lg-9">
                    <slot></slot>
                </div>
            </div>
        </div>
    </layout>

</template>

<script>

import Layout from "../../Layout";

export default {

    components: {
        Layout,
    },

    name:'MyAccountLayout',

}

</script>
